"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("./offer-styles");

var _detailsTabs = require("../common/details-tabs");

var _details = require("./details");

var _jsxRuntime = require("react/jsx-runtime");

var LoanDetails = function LoanDetails(_ref) {
  var _loanOffer$specifics$, _loanOffer$specifics, _loanOffer$specifics$2, _loanOffer$specifics$3, _loanOffer$specifics2, _loanOffer$specifics3, _loanOffer$specifics$4, _loanOffer$specifics4, _loanOffer$specifics5, _loanOffer$specifics$5, _loanOffer$specifics6, _loanOffer$specifics7, _loanOffer$specifics$6, _loanOffer$specifics8, _loanOffer$specifics9, _loanOffer$specifics$7, _loanOffer$specifics$8, _loanOffer$specifics10, _loanOffer$specifics11, _loanOffer$specifics$9, _loanOffer$specifics12, _loanOffer$specifics13;

  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = _details.LOAN_DETAILS;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      handleShownTab: handleShownTab,
      title: title
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.Ranges, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.Range, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.RangeTitle, {
          size: "xs",
          bold: true,
          light: true,
          children: (_loanOffer$specifics$ = (_loanOffer$specifics = loanOffer.specifics) === null || _loanOffer$specifics === void 0 ? void 0 : (_loanOffer$specifics$2 = _loanOffer$specifics.fundingAmount) === null || _loanOffer$specifics$2 === void 0 ? void 0 : _loanOffer$specifics$2.category) !== null && _loanOffer$specifics$ !== void 0 ? _loanOffer$specifics$ : ''
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          bold: true,
          children: (_loanOffer$specifics$3 = (_loanOffer$specifics2 = loanOffer.specifics) === null || _loanOffer$specifics2 === void 0 ? void 0 : (_loanOffer$specifics3 = _loanOffer$specifics2.fundingAmount) === null || _loanOffer$specifics3 === void 0 ? void 0 : _loanOffer$specifics3.description) !== null && _loanOffer$specifics$3 !== void 0 ? _loanOffer$specifics$3 : ''
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.Range, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.RangeTitle, {
          size: "xs",
          bold: true,
          light: true,
          children: (_loanOffer$specifics$4 = (_loanOffer$specifics4 = loanOffer.specifics) === null || _loanOffer$specifics4 === void 0 ? void 0 : (_loanOffer$specifics5 = _loanOffer$specifics4.cost) === null || _loanOffer$specifics5 === void 0 ? void 0 : _loanOffer$specifics5.category) !== null && _loanOffer$specifics$4 !== void 0 ? _loanOffer$specifics$4 : ''
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          bold: true,
          children: (_loanOffer$specifics$5 = (_loanOffer$specifics6 = loanOffer.specifics) === null || _loanOffer$specifics6 === void 0 ? void 0 : (_loanOffer$specifics7 = _loanOffer$specifics6.cost) === null || _loanOffer$specifics7 === void 0 ? void 0 : _loanOffer$specifics7.description) !== null && _loanOffer$specifics$5 !== void 0 ? _loanOffer$specifics$5 : ''
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.Range, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.RangeTitle, {
          size: "xs",
          bold: true,
          light: true,
          children: (_loanOffer$specifics$6 = (_loanOffer$specifics8 = loanOffer.specifics) === null || _loanOffer$specifics8 === void 0 ? void 0 : (_loanOffer$specifics9 = _loanOffer$specifics8.repaymentTerms) === null || _loanOffer$specifics9 === void 0 ? void 0 : _loanOffer$specifics9.category) !== null && _loanOffer$specifics$6 !== void 0 ? _loanOffer$specifics$6 : ''
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          bold: true,
          children: (_loanOffer$specifics$7 = loanOffer.specifics.repaymentTerms.description) !== null && _loanOffer$specifics$7 !== void 0 ? _loanOffer$specifics$7 : ''
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.Range, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.RangeTitle, {
          size: "xs",
          bold: true,
          light: true,
          children: (_loanOffer$specifics$8 = (_loanOffer$specifics10 = loanOffer.specifics) === null || _loanOffer$specifics10 === void 0 ? void 0 : (_loanOffer$specifics11 = _loanOffer$specifics10.fundingSpeed) === null || _loanOffer$specifics11 === void 0 ? void 0 : _loanOffer$specifics11.category) !== null && _loanOffer$specifics$8 !== void 0 ? _loanOffer$specifics$8 : ''
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          bold: true,
          children: (_loanOffer$specifics$9 = (_loanOffer$specifics12 = loanOffer.specifics) === null || _loanOffer$specifics12 === void 0 ? void 0 : (_loanOffer$specifics13 = _loanOffer$specifics12.fundingSpeed) === null || _loanOffer$specifics13 === void 0 ? void 0 : _loanOffer$specifics13.description) !== null && _loanOffer$specifics$9 !== void 0 ? _loanOffer$specifics$9 : ''
        })]
      })]
    })]
  });
};

var _default = LoanDetails;
exports["default"] = _default;
//# sourceMappingURL=loan-details.js.map